import React, { useState, useEffect } from "react";
import { useCCContext } from "../CC/CCContext";
import * as ccUtils from "../CC/utils";
import styles from "./ObjAssoc.module.css";
//import ObjAssocIcon from "./ObjAssocIcon";

interface RecordProps {
  record: any; // Pas aan als je het exacte type kent
  inheritance: any;
}

const ObjAssoc: React.FC<RecordProps> = ({ record, inheritance }) => {
  const [relatedRecords, setRelatedRecords] = useState<any[]>([]);
  const ctx = useCCContext();

  useEffect(() => {
    const fetchRelatedRecords = async () => {
      if (inheritance==='child' && !record?.data?.record?.relatedchild) { setRelatedRecords([]); return;}
      if (inheritance==='parent' && !record?.data?.record?.relatedparent)  { setRelatedRecords([]); return;}

      var relatedIdsArray
      if (inheritance==='child') {
        relatedIdsArray = Array.isArray(record.data.record.relatedchild)
        ? record.data.record.relatedchild
        : [record.data.record.relatedchild];
      }
      if (inheritance==='parent') {
        relatedIdsArray = Array.isArray(record.data.record.relatedparent)
        ? record.data.record.relatedparent
        : [record.data.record.relatedparent];
      }


      try {
        const fetchedRecords = await Promise.all(
          relatedIdsArray.map(async (relatedId: string) => {
            const url = `${process.env.REACT_APP_CC_URL}/?action=get&command=search&query=ccobjectid=${relatedId}&fields=*&responseFormat=json`;
            //console.log(`Fetching: ${url}`);

            const response = await fetch(url);
            if (!response.ok) {
              return null;
            }

            const data = await response.json();
            return data?.records?.record ?? null;
          })
        );

        setRelatedRecords(fetchedRecords.filter((rec) => rec !== null).sort((a, b) => a?.data?.record?.objectnumber.localeCompare(b?.data?.record?.objectnumber)));
      } catch (error) {
        console.error("Error fetching related records:", error);
      }
    };

    fetchRelatedRecords();
  }, [record]);

  const handleLinkClick = (event: React.MouseEvent, index: number) => {
    event.preventDefault();

    //const objectNumber = relatedRecords[index]?.data?.record?.objectnumber || "Onbekend";
    const ccobjectid = relatedRecords[index]?.data?.record?.ccobjectid;


    ccUtils.customSearch(
      ctx,
      "/Record/ccobjectid",
      "",
      `[${ccobjectid}]`,
      `notice liées: ${ccobjectid}`
    );
  };

  return relatedRecords.length > 0 ? (
    <div className={styles.ObjAssoc}>
      <div><b>{inheritance==='parent' ? "Cet objet fait partie d'un ensemble :" : "Cette notice décrit un ensemble :"}</b></div>
      {relatedRecords.length > 0 ? (
      relatedRecords.map((rec: any, index: number) => (
        <div className={styles.row} key={index} style={{ marginLeft: '20px' }}>
        <span onClick={(event) => handleLinkClick(event, index)} className={styles.assocLink} style={{cursor: 'cursor'}}>
          {rec?.data?.record?.title?.title}, {rec?.data?.record?.objectnumber}</span>
        </div>

        
        ))
      ) : (
        <p></p>
      )}
    </div>
  ) : <p></p>;
};

export default ObjAssoc;

/*
<ObjAssocIcon
            key={index}
            record={rec}
            index={index}
            handleLinkClick={handleLinkClick}
          />
*/